const Dossier = () => import('@/components/dossier/Dossier.vue')

export default [
  {
    path: '/dossier/:type/:noDossier/:noCpl',
    name: 'Dossier',
    component: Dossier
  }
]
